import { render, staticRenderFns } from "./CarrierDetail.vue?vue&type=template&id=18580edd&scoped=true&"
import script from "./CarrierDetail.vue?vue&type=script&lang=js&"
export * from "./CarrierDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18580edd",
  null
  
)

export default component.exports